export default __webpack_public_path__ + "static/media/maracuja.b17cdcfc.jpg";